import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { AccountTicketsActions } from './+state/account-tickets.actions';
import { AccountTicketsEpics } from './+state/account-tickets.epic';
import { AccountTicketsFacade } from './+state/account-tickets.facade';


@NgModule({
    declarations: [],
    imports: [
        CommonModule
    ],
    providers: [AccountTicketsActions, AccountTicketsFacade, AccountTicketsEpics]
})
export class AccountTicketsModule {}
